<template>
    <body>
    <div id="fix_header">
        <h2>
            <button class="button_back" @click="goHome">&#11013; back</button>
            <span style="font-size: 15px;color: yellow">{{count_my_appointments}}</span> Appoint's
            <button class="buton_add" @click="goNewAppo">New Appointment</button>
        </h2>
        <input v-if="count_my_appointments>0" type="text" id="searchInput" @keyup="searchAppointment()" placeholder="Filter by Office" title="Type name...">
    </div>
    <br>
    <hr>
    <div v-if="count_my_appointments == 0">
        {{this.error_message}}
    </div>
    <div v-else style="overflow-x: auto">
        <table id="bmTable" >
            <tr class="header">
                <th width="20%"><i class="fa fa-calendar" aria-hidden="true"></i> Date</th>
                <th width="30%"><i class="fa fa-commenting" aria-hidden="true"></i> Comment</th>
                <th width="20%"><i class="fa fa-building" aria-hidden="true"></i> Office</th>
                <th width="20%"><i class="fa fa-map-marker" aria-hidden="true"> Location</i></th>
                <th width="10%"><i class="fa fa-question-circle" aria-hidden="true"> Status</i></th>
                <!--<th width="5%">Delete</th>-->
            </tr>
            <tr v-for="(appointment) in this.appointments " :key="appointment.index">
                <td>
                    <span v-if="!expired(appointment)">{{appointment.date}}</span>
                    <span  style="background-color: orangered;padding: 5px 5px " v-else>{{appointment.date}}</span>
                </td>
                <td style="font-size: 11px">{{extractComment(appointment.comment)}}</td>
                <td>{{appointment.office}}</td>
                <td>{{appointment.location}}</td>
                <td>
                    <span v-if="!expired(appointment)">
                        <button v-if="appointment.status === 1" class="text_btn confirm">
                            <i  class="fa fa-check-circle" aria-hidden="true"></i>
                        </button>
                        <button  class="text_btn request" v-else-if="appointment.status === 0">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                        </button>
                        <button  class="text_btn cancel" v-else>
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </button>
                    </span>
                    <span v-else>
                        <button  class="text_btn expired">
                            <i class="fa fa-hourglass-end" aria-hidden="true"></i>
                        </button>
                    </span>
                </td>
                <!--
                <td>
                    <button :disabled="checkAppointment(appointment.id,appointment.hid)" class="text_btn danger" @click="deleteAppointment(appointment,index)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </td>
                -->
            </tr>
        </table>
        <!-- MOBILE TABLE -->
        <div id="mobileTable" v-for="(appointment) in this.appointments " :key="appointment.index">
            <div class="client_card" >
                <div class="client_card_container" >
                     <span v-if="appointment.status === 1" class="text_btn analytics" style="float:left">
                        <i  class="fa fa-check-circle" aria-hidden="true"></i>
                    </span>
                    <span  v-else-if="appointment.status === 0" class="text_btn request" style="float:left" >
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </span>
                    <span style="float:left" v-else>
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </span>

                    <span class="title" v-if="!expired(appointment)">{{appointment.date}}</span>
                    <span class="title" v-else style="color: lightpink;">{{appointment.date}}</span>
                   <!-- <span class="title">{{appointment.office}}</span>-->

                    <span class="comment" @click="showInfo(extractComment(appointment.comment))">
                        <i class="fa fa-commenting" aria-hidden="true"></i>
                    </span>
                    <span class="location" @click="showInfo(appointment.office)">
                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                    </span>
                    <!--
                    <button :disabled="checkAppointment(appointment.id,appointment.hid)" class="text_btn danger" @click="deleteAppointment(appointment,index)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                    -->
                </div>
            </div>
            <br>
        </div>
        <!-- status history -->
        <br>
        <div id="mobile_legend" class="legend">
            <i class="fa fa-commenting" aria-hidden="true"></i> Comment
            <i class="fa fa-map-marker" aria-hidden="true"></i> Office
            <!--<i class="fa fa-trash-o" aria-hidden="true"></i> Delete-->
        </div>
        <div>
            <span class="text_btn confirm">
                <i  class="fa fa-check-circle" aria-hidden="true"></i><span style="font-size: 7px"> confirmed</span>
            </span>
            <span  class="text_btn request">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i><span style="font-size: 7px"> requested</span>
            </span>
            <span  class="text_btn cancel">
                <i class="fa fa-times" aria-hidden="true"></i><span style="font-size: 7px"> rejected</span>
            </span>
            <span class="text_btn expired">
                <i class="fa fa-hourglass-end" aria-hidden="true"></i><span style="font-size: 7px"> expired</span>
            </span>
        </div>
    </div>
    </body>
</template>
<script>
    import {getClientProfile} from "../hid.js"
    import {getBaseURL} from '../url_endpoints'
    export default {
        name: 'History',
        data() {
            return {
                appointments:[],
                offices:[],
                fix_header:null,
                sticky_zone:null,
                baseURL: null,
                error_message:'No Appointments found!',
            }
        },
        mounted() {
            const profile = getClientProfile()
            if(!profile) {
                alert('To check appointments history...\nPlease first create a profile !')
                this.$router.push('/profile')
            } else {
                this.fix_header = document.getElementById('fix_header')
                this.sticky_zone = this.fix_header.offsetTop
                window.onscroll = () => this.setStickyHeader()
                // set back-end endpoints
                this.baseURL = getBaseURL()
                // get offices info from backend and then customer appointments
                this.getOfficesData()
            }
        },
        computed: {
            count_my_appointments() {
                return this.appointments.length
            }
        },
        methods: {
            extractComment(comment){
                const ecomment = comment.split('>')
                return ecomment.length > 1 ? ecomment[1] : comment
            },
            expired(appointment) {
                const adate = appointment.date.split(' # ')
                const adate_format = adate[0].split('/')
                const atime_format = adate[1].split(':')
                const appo = new Date(adate_format[0],adate_format[1]-1,adate_format[2],atime_format[0],atime_format[1])
                let today = new Date()
                return appo < today ? true : false
            },
            showInfo(info){
              alert(info)
            },
            checkAppointment(id, hid) {
                // check HID owner
                let profile = getClientProfile()
                return ((id === 0) || !hid.match(profile.hid)) ? true : false
            },
            setStickyHeader() {
                if(window.pageYOffset > this.sticky_zone){
                    this.fix_header.classList.add('sticky_header')
                } else {
                    this.fix_header.classList.remove('sticky_header')
                }
            },
            searchAppointment() {
                let input, filter, table, tr, td, txtValue
                input = document.getElementById("searchInput")
                filter = input.value.toUpperCase()
                table = document.getElementById("bmTable")
                tr = table.getElementsByTagName("tr")
                for(let i = 0; i < tr.length; i++) {
                    td = tr[i].getElementsByTagName("td")[2] // get Office name
                    if (td) {
                        txtValue = td.textContent || td.innerText
                        if (txtValue.toUpperCase().indexOf(filter) > -1) {
                            tr[i].style.display = ""
                        } else {
                            tr[i].style.display = "none"
                        }
                    }
                }
            },
            computeSlotString(slot) {
                //console.log(slot)
                let slotmodel = '00:00'
                let time_minutes = slot.split(':')
                if(time_minutes[0].length == 1) {
                    slotmodel = '0'+ time_minutes[0] +':'
                } else {
                    slotmodel = time_minutes[0] + ':'
                }
                if(time_minutes[1].length == 1) {
                    slotmodel = slotmodel +'0'+ time_minutes[1]
                } else {
                    slotmodel = slotmodel + time_minutes[1]
                }
                return slotmodel
            },
            getAppointments() {
                // check HID owner
                let profile = getClientProfile()
                fetch(this.baseURL + '/appointments?hid='+profile.hid).then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    for(let a of response) {
                        let officedata = this.getOfficeInfo(a.office);
                        let appointment = {
                            id:a.id,
                            hid:a.hid,
                            office:officedata.name,
                            location:officedata.location,
                            type:officedata.type,
                            date:a.year+'/'+(a.month+1)+'/'+a.day + ' # ' +this.computeSlotString(a.slot),
                            status: a.status,//this.setStatus(a.year,a.month,a.day),
                            comment:a.comment,
                        }
                        this.addAppointmentByDate(appointment)
                    }
                }).catch(err => {
                    alert(err.message +'\nBackend Server could be down!\nPlease try again later....')
                    this.error_message = 'Backend Server not working!'
                    //console.log('Error when get appointments', err.message)
                })
            },
            addAppointmentByDate(appointment) {
                // compare appointment date with first element of array
                let endinsert = true
                if(this.appointments.length === 0) {
                    this.appointments.push(appointment)
                } else {
                    const appo_date = appointment.date.split(' # ')
                    const in_date = new Date(appo_date[0])
                    // search position to insert
                    for(let i = 0; i< this.appointments.length; i++ ) {
                        let i_from_array = this.appointments[i].date
                        // date_part[0] - date , date_part[1] - time
                        let i_date_part = i_from_array.split(' # ')
                        let idate = new Date(i_date_part[0])
                        if (in_date > idate) {
                            //console.log('pass')
                        } else {
                            // insert
                            this.appointments.splice(i,0,appointment)
                            endinsert = false
                            break;
                        }
                    }
                    if(endinsert) {
                        this.appointments.push(appointment)
                    }
                }
            },
            deleteAppointment(appointment,index){
                let y = confirm(`This action will delete the next appointment\nOffice: ${appointment.office} \nDate: ${appointment.date}\nAre You sure ?`)
                if(y) {
                    fetch(this.baseURL + '/appointments/' + appointment.id, {
                        method: 'DELETE'
                    }).then( rsp =>{
                        return rsp.json()
                    }).then( () => {
                        // console.log('Delete appointment proceeded...')
                        // update frontend sites data
                        this.appointments.splice(index,1)
                    }).catch(err => {
                        //console.log('Error when delete appointment ...'+err.message)
                        this.error_message = err.message
                    })
                }
            },
            getOfficesData() {
                fetch(this.baseURL + '/offices').then(rsp => {
                    return rsp.json()
                }).then( response => {
                    //console.log(response)
                    for(let office of response) {
                        this.offices.push(office)
                    }
                    this.getAppointments()
                }).catch(err => {
                    alert(err.message+'\nBackend Server could be down\nPlease try again later....')
                    this.error_message = 'Backend Server could be down!'
                    //console.log('Error when get offices', err.message)
                })
            },
            getOfficeInfo(index){
                let officedata ={
                    name:'',
                    location:'',
                    type:''
                }
                for(let o of this.offices) {
                    if(o.id === index) {
                        officedata = {
                            name: o.name,
                            location: o.location,
                            type: o.type,
                        }
                    }
                }
                return officedata
            },
            goHome() {
                this.$router.push('/client')
                window.scrollTo(0,0)
            },
            goNewAppo() {
                this.$router.push('/new_appointment')
                window.scrollTo(0,0)
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        height:100vh;
    }
    @media screen and (min-width: 601px){
        #mobileTable {
            display:none;
        }
        #searchOnMobile {
            display: none;
        }
        #mobile_legend {
            display:none
        }
    }
    @media screen and (max-width: 600px) {

        #bmTable {
            display: none;
        }
        #searchInput {
            display: none;
        }

        #bmTable tr {
            font-size: 8px;
        }
        #searchInput {
            display: none;
        }
        #fix_header {
            width: 100%;
        }
        h2 {
            font-size: 12px;
        }
        button {
            font-size: 7px;
        }
        h5 {
            font-size: 8px;
        }
        h3 {
            font-size: 10px;
        }
        .input-field {
            font-size: 10px;
        }
    }
    // add client cards for mobile
    .client_card {
        /* Add shadows to create the "card" effect */
        box-shadow: 0 4px 8px 0 whitesmoke;
        background-color: darkslategrey;
        color: black;
        transition: 0.3s;
        border-radius: 10px;
    }

    /* On mouse-over, add a deeper shadow */
    .client_card:hover {
        box-shadow: 0 8px 16px 0 lightgoldenrodyellow;
        background-color: lightslategrey;
    }

    /* Add some padding inside the card container */
    .client_card_container {
        padding: 5px;
    }
    .title {
        //font-weight: bold;
        font-size: 11px;
        padding: 5px 5px;
        color: lightcyan;
        float: left;
    }

    * {
        box-sizing: border-box;
    }
    #searchInput {
        background-image: url('../assets/search_icon_25.png');
        background-position: 5px 5px;
        background-repeat: no-repeat;
        width: 30%;
        font-size: 12px;
        padding: 10px 20px 10px 40px;
        border: 1px solid #ddd;
        margin-bottom: 12px;
    }
    /*
    #searchOnMobile {
        background-image: url('../assets/search_icon_25.png');
        background-position: 5px 5px;
        background-repeat: no-repeat;
        width: 100%;
        font-size: 12px;
        padding: 10px 20px 10px 40px;
        border: 1px solid #ddd;
        margin-bottom: 12px;
    }*/

    #bmTable {
        border-collapse: collapse;
        width: 100%;
        border: 1px solid #ddd;
        font-size: 15px;
    }

    #bmTable th, #bmTable td {
        text-align: left;
        padding: 12px;
       // color: white;
    }
    #bmTable tr {
        border-bottom: 1px solid #ddd;
    }

    #bmTable tr.header {
        background-color: dimgray;
    }
    #bmTable tr:hover {
        background-color: darkslategrey;
        color:lightcyan;
    }
    // ******************** round button
    .button_home {
        background-color: yellow;
        color: black;
        border: none;
        padding: 5px 5px;
        font-size: 14px;
        font-family: Raleway;
        cursor: pointer;
        border-radius: 10px;
        opacity: 0.8;
        margin-left: 5px;
    }
    .button_home:hover {
        opacity: 1.0;
    }
    .buton_add {
        @extend .button_home;
        background-color: lightseagreen;
        color: white;
        float:right;
    }
    .button_back {
       @extend .button_home;
        float: left;
        background-color: white;
        //float:left;
    }

    // add sticky header of this wiew
    .sticky_header {
        position: fixed;
        top:0;
        left:0;
        width: 100%;
        background-color: #2c3e50;
        z-index: 1;
    }

    /* The Close Button */
    .close {
        color: white;
        float: right;
        font-size: 28px;
        font-weight: bold;
    }
    .close:hover,
    .close:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }
    .comment {
        color:white;
        opacity:0.7;
        padding: 10px;
    }
    .comment:hover {
        opacity: 1.0
    }
    .location {
        padding: 10px 10px;
        color: lightcyan;
    }
    .legend {
        font-size: 12px;
        color: lightyellow;
    }
    // import text buttons styles
    @import "../assets/css/text_buttons";
</style>